import { countryProfile, type CountryProfile, type SessionUser, type UiLocale } from '@his/shared';

export function profileUsesLanguage(profile: CountryProfile, locale: UiLocale): boolean {
  return profile.locales.documentSecondary === locale || profile.locales.ui.includes(locale);
}

export function tenantUsesLanguage(user: Pick<SessionUser, 'locale' | 'branches'> | null | undefined, locale: UiLocale): boolean {
  if (!user) return false;
  if (user.locale === locale) return true;
  return (user.branches ?? []).some((branch) => profileUsesLanguage(countryProfile(branch.country), locale));
}

export function tenantUsesArabic(user: Pick<SessionUser, 'locale' | 'branches'> | null | undefined): boolean {
  return tenantUsesLanguage(user, 'ar');
}

export function tenantSecondaryLanguages(user: Pick<SessionUser, 'branches'> | null | undefined): UiLocale[] {
  const found = new Set<UiLocale>();
  for (const branch of user?.branches ?? []) {
    const secondary = countryProfile(branch.country).locales.documentSecondary;
    if (secondary) found.add(secondary);
  }
  return [...found];
}
